export default __webpack_public_path__ + "static/media/pictogramBeaconShortcuts128.3037fe62.svg";